import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import moment from 'moment';
import React from 'react';
import Layout from '../components/base/Layout';
import PageHead from '../components/base/PageHead';
import ResourceHero from '../components/organisms/ResourceHero';
import ResourceShareSheet from '../components/organisms/ResourceShareSheet';
import CtaSection from '../components/sections/CtaSection';

const ChangelogEntry = ({ data: { entry } }): JSX.Element => {
  return (
    <Layout>
      <ResourceHero
        title={entry.title}
        date={moment.utc(entry.date).format('MMMM DD, YYYY')}
        backButton={{ label: 'Return to Changelog', url: '/changelog' }}
      />

      <div className="container justify-between mb-16 lg:space-x-8 lg:flex">
        <div className="lg:w-1/2">
          {entry.image && (
            <div className="mb-6">
              <GatsbyImage
                image={getImage(entry.image)}
                alt={entry.image.title}
                className="w-full h-auto rounded-md"
              />
            </div>
          )}
        </div>
        <div
          className="prose lg:w-1/2"
          dangerouslySetInnerHTML={{
            __html: documentToHtmlString(JSON.parse(entry.content.raw)),
          }}
        />
      </div>

      <ResourceShareSheet
        title={entry.title}
        backButtonUrl="/changelog"
        shareUrl=""
      />
      <CtaSection headline="StackScout gives you a 24/7 insight into the state of your servers. Start your free trial now." />
    </Layout>
  );
};

export const Head = ({ data: { entry } }) => <PageHead title={entry.title} />;

export const pageQuery = graphql`
  query ChangelogEntryQuery($id: String!) {
    entry: contentfulChangelogEntry(id: { eq: $id }) {
      title
      date
      image {
        title
        gatsbyImageData(width: 1504)
      }
      content {
        raw
      }
    }
  }
`;

export default ChangelogEntry;
